import { ButtonSize } from 'components/Button/Types'
import { IconButton } from 'components/IconButton/IconButton'
import { useViewPreferencesStore } from 'screens/Finder/components/ViewPreferences/stores/useViewPreferencesStore'

import Styles from './BackButton.module.scss'
import { ArrowLeft } from 'almanac-ui/icons/16'

const BackButton = ({ onPress, size = 'md' }: { onPress?: () => void; size?: ButtonSize }) => {
  const { setOpenedViewPreference } = useViewPreferencesStore()

  return (
    <IconButton
      icon={ArrowLeft}
      size={size}
      className={Styles.backButton}
      onPress={onPress || (() => setOpenedViewPreference('all'))}
      data-testid="view-preference-back-button"
    />
  )
}

export { BackButton }
